export const EXPERIMENT_KEY = 'guru_ai_rollout'
export const CONVERSATION_ONBOARDING_STORAGE_KEY = 'guru-ai-onboarding'
export const CONVERSATION_LANDING_ONBOARDING_STORAGE_KEY =
  'guru-ai-landing-onboarding'
export const CONVERSATION_STORAGE_KEY = 'guru-ai-conversation'
